import { Palette } from "@mui/material";

export const generateSelectedRange = (palette: Palette) => ({
  borderTop: `1px solid ${palette.primary.main}`,
  borderBottom: `1px solid ${palette.primary.main}`,
  backgroundColor: palette.grey[100]
});
export const generateRightSelectedRange = (palette: Palette, borderRadius: number) => ({
  borderLeft: `1px solid ${palette.primary.main}`,
  borderTopLeftRadius: borderRadius === 0 ? 0 : "50%",
  borderBottomLeftRadius: borderRadius === 0 ? 0 : "50%",
  backgroundColor: palette.grey[100],
  "&:first-of-type": {
    borderBottomLeftRadius: borderRadius === 0 ? 0 : "50%",
    borderTopLeftRadius: borderRadius === 0 ? 0 : "50%"
  }
});

export const generateLeftSelectedRange = (palette: Palette, borderRadius: number) => ({
  borderRight: `1px solid ${palette.primary.main}`,
  backgroundColor: palette.grey[100],
  borderTopRightRadius: borderRadius === 0 ? 0 : "50%",
  borderBottomRightRadius: borderRadius === 0 ? 0 : "50%",
  "&:last-of-type": {
    borderBottomRightRadius: borderRadius === 0 ? 0 : "50%",
    borderTopRightRadius: borderRadius === 0 ? 0 : "50%"
  }
});

export const dateSizeStyles = (borderRadius: number) => ({
  fontSize: 16,
  width: 40,
  height: 40,

  borderTopLeftRadius: borderRadius === 0 ? 0 : "50%",
  borderBottomLeftRadius: borderRadius === 0 ? 0 : "50%",

  borderTopRightRadius: borderRadius === 0 ? 0 : "50%",
  borderBottomRightRadius: borderRadius === 0 ? 0 : "50%"
});

export const focusDisableStyles = (palette: Palette) => ({
  ":focus": {
    backgroundColor: "transparent",
    "&.Mui-selected": {
      backgroundColor: palette.primary.main
    }
  }
});
